import {
  SkeletonTextMedium,
  SkeletonTextSmall
} from '~/components/common/Carousel/Carousel.styles';
import { CarouselSettings } from '~/components/common/Carousel/types';

export default function Headings({
  eventBaseName,
  heading,
  isSkeleton,
  sectionName,
  subHeading,
  viewLinkText,
  viewLinkUrl
}: Partial<CarouselSettings>) {
  return (
    <div className="flex flex-col items-start gap-4 m:gap-8">
      <h2 className="text-blue-6 tl-header-s s:tl-header-m l:tl-header-xl">
        {isSkeleton ? (
          <SkeletonTextMedium className="w-[120px] s:w-[220px]" />
        ) : (
          heading
        )}
      </h2>
      {subHeading && (
        <h3>
          <small className="flex text-grey-5 s:tl-body-m l:tl-body-l">
            {isSkeleton ? (
              <SkeletonTextSmall className="w-[100px] s:w-[160px]" />
            ) : (
              subHeading
            )}
          </small>
        </h3>
      )}
      {viewLinkUrl && (
        <a
          className="!no-underline tl-link-m"
          href={viewLinkUrl}
          data-analytics-id={`${eventBaseName} - View more results`}
          data-analytics-attributes={JSON.stringify({
            sectionName: sectionName || heading,
            viewLinkUrl
          })}
        >
          {viewLinkText ? viewLinkText : 'View More'}
        </a>
      )}
    </div>
  );
}
